exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".posters-overlay{width:100vw;height:100vh;pointer-events:none}.posters-overlay .poster{position:absolute;width:350px}.posters-overlay .poster height 497px,.posters-overlay .poster img{width:100%}.posters-overlay .poster:first-child{top:10px;left:-200px;transform:rotate(-8deg);z-index:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f4e815cc","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/sections/amerikkkan/_components/poster-overlay.vue
// module id = 562
// module chunks = 0